export enum IMAGE {
  NOT_FOUND = 'https://www.navigation.com/static/WFS/Shop-Site/-/Shop/en_US/Product%20Not%20Found.png',
}
